import * as React from "react";
import { Context } from "./_context";
export const AfterpayHomeIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.4 2.2a1 1 0 0 1 1.06-.088l.14.088 8 6a1 1 0 0 1 .4.8v11a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-4h-2v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 .31-.725L3.4 8.2l8-6ZM5 9.5V19h4v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4h4V9.499l-7-5.25-7 5.25Z", fill: "currentColor" }));
  return iconset[size];
};
AfterpayHomeIcon.iconId = "Lpq3ZY";
